import { __assign, __rest } from "tslib";
import * as React from 'react';
import { TranslationsProvider } from '../../i18next';
import { NamespacesConsumer } from 'react-i18next';
import { HeaderHolidaySale, } from './header-holiday-sale';
function HeaderHolidaySaleExport(_a) {
    var locale = _a.locale, holidaySaleHeaderProps = __rest(_a, ["locale"]);
    return (React.createElement(TranslationsProvider, { locale: locale },
        React.createElement(NamespacesConsumer, null, function (t) { return React.createElement(HeaderHolidaySale, __assign({}, holidaySaleHeaderProps, { t: t })); })));
}
export { HeaderHolidaySaleExport };
//# sourceMappingURL=header-holiday-sale-export.js.map